import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { QuestionModule } from '../../../appshared/Main/question/question.module';
import { QuestionService } from '../../../appshared/Main/question/question.service';
import { LocalStoreService } from '../../../layouts/local-store.service';

@Component({
    selector: 'app-question',
    templateUrl: './question.component.html',
    styleUrls: ['./question.component.scss']
})
export class QuestionComponent implements OnInit {

    thisID: number = 0;
    private sub: any;
    private data: any;
    constructor( public service: QuestionService, private toastr: ToastrService, private router: Router, private route: ActivatedRoute, private localS: LocalStoreService) { }

    ngOnInit(): void {
        this.sub = this.route.params.subscribe(params => {
            this.thisID = +params['QId'];
            this.buildItemForm();
        });

    }

    question: string = "";
    answers1: string = "";
    answers2: string = "";
    answers3: string = "";
    answers4: string = "";

    buildItemForm() {

        /*  this.loader.open();*/
        this.service.getServiceId(this.thisID)
            .subscribe(res => {
                this.data = res as QuestionModule[];
                this.question = this.data.question;
                this.answers1 = this.data.answer1;
                this.answers2 = this.data.answer2;
                this.answers3 = this.data.answer3;
                this.answers4 = this.data.answer4;
                /* this.loader.close();*/
            },
                err => {
                   /* this.loader.close();*/ console.log(err);
                    this.toastr.error('خطأ', '');
                    this.router.navigate(['home']);
                }
            );

    }

    onClick(answer1: boolean, answer2: boolean, answer3: boolean, answer4: boolean, fullName: string, phoneNo: string, address: string) {



        var SQuestion = this.localS.getItem("Question");

        try {
            if (SQuestion == this.thisID) {

                this.toastr.error('لقد إشتركت مسبقاً', 'خطأ');
                return;
            }
        } catch { }


        if ((answer1 || answer2 || answer3 || answer4) && fullName.length > 5 && phoneNo.length > 7 && address.length > 3) {
            var answerNo = 0;
            var answerName = '';
            if (answer1) {
                answerNo = 1;
                answerName = this.answers1;
            }
            else if (answer2) {
                answerNo = 2;
                answerName = this.answers2;
            }
            else if (answer3) {
                answerNo = 3;
                answerName = this.answers3;
            }
            else if (answer4) {
                answerNo = 4;
                answerName = this.answers4;
            }
            //this.loader.open();
            this.service.getInsertAnswer(this.thisID, answerNo, answerName, fullName, phoneNo, address)
                .subscribe(res => {
                    //   this.loader.close();

                    if (res == 'success') {

                        this.localS.setItem("Question", this.thisID);

                        this.toastr.success('تم حفظ الإجابة', 'شكراً لمشاركتكم');
                        this.router.navigate(['/']);
                    }
                    else {


                        this.toastr.error(res, 'خطأ');
                        this.router.navigate(['/']);
                    }

                }, err => {
                    // this.loader.close();
                    console.log(err);
                });


            /* this.toastr.success(answer1 + ' - ' + answer2 + ' - ' + answer3 + ' - ' + answer4 + ' - ' + fullName + ' - ' + phoneNo + ' - ' + address + ' - ', '');*/
        }
        else {
            this.toastr.error('الرجاء تعبئة كل البيانات', 'خطأ')
        }


    }

}
